import { ForceMobileUpdateForm } from "./ForceMobileUpdateForm";

export const ForceMobileUpdatePage = () => {
  return <ForceMobileUpdateForm />;
};
